import { Tooltip } from 'antd'
import _ from 'lodash'
import { Grid3x3Icon, LucideProps, MapIcon, WorkflowIcon } from 'lucide-react'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'

const MenuContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  align-items: end;
  gap: 8px;
  width: ${({ $isOpen }) => ($isOpen ? '120px' : '0px')};
  transition: width 500ms;
`

const ButtonContainer = styled.div<{ $isSelected: boolean }>`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 1rem;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.forecast.text3 : theme.forecast.background2_5};
  color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.forecast.background2_5 : theme.forecast.text3};
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    width 200ms,
    height 200ms,
    transform 400ms;

  &:hover {
    background-color: ${({ $isSelected, theme }) =>
      $isSelected ? theme.forecast.text2 : theme.forecast.background3};
    width: 56px;
    height: 56px;
  }
`

interface HudMenuProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  selectedLayers: string[]
  onLayerSelect: Dispatch<'map' | 'point'>
}

export const LayersMenu: FC<HudMenuProps> = (props) => {
  const SelectLayerButton = ({ layer }: { layer: 'map' | 'point' }) => {
    const layerIcons = {
      map: (props: LucideProps) => <MapIcon {...props} />,
      flow: (props: LucideProps) => <WorkflowIcon {...props} />,
      point: (props: LucideProps) => <Grid3x3Icon {...props} />,
    }
    const Icon = layerIcons[layer]
    return (
      <ButtonContainer
        $isSelected={props.selectedLayers?.includes(layer) ?? false}>
        <Tooltip title={_.capitalize(layer)} placement='top'>
          <Icon
            onClick={() => props.onLayerSelect(layer)}
            style={{
              width: '80%',
              height: '80%',
            }}
          />
        </Tooltip>
      </ButtonContainer>
    )
  }
  return (
    <MenuContainer $isOpen={props.isOpen}>
      <SelectLayerButton layer={'map'} />
      <SelectLayerButton layer={'point'} />
    </MenuContainer>
  )
}
